export default __webpack_public_path__ + "static/media/supplier-2.a9a71078.png";